// a function that generates a unique id using the execution timestamp, a random number and a random letter from A-Z
const generateUniqueId = () => {
  let timestamp = Date.now().toString(36);
  let randomNum = Math.floor(Math.random() * 1000000).toString(36);
  let randomLetter = String.fromCharCode(65 + Math.floor(Math.random() * 26));
  return `${timestamp}-${randomNum}-${randomLetter}`;
};

const internalDataLayer = (event, data) => {
  if (!window.dataLayer) {
    window.dataLayer = [];
    console.warn('Data Layer not found, creating instance...');
  }

  let eventId = generateUniqueId();
  let eventData = { eventId, ...data };

  return window.dataLayer[event](eventData);
};

export const pushEvent = data => {
  if (!data) return;
  internalDataLayer('push', data);
};
